import { VNTANA_API_BASE } from "@/constants/index"

export const parseVntanaUrl = url => {
  const parsed = new URL(url)

  if (!parsed.host.includes("embed.vntana.com")) {
    throw new Error("Invalid VNTANA embed URL")
  }

  const organization = parsed.searchParams.get("organizationSlug")
  const client = parsed.searchParams.get("clientSlug")
  const product = parsed.searchParams.get("productUuid")

  if (!organization || !client || !product) {
    throw new Error("Missing required VNTANA params")
  }

  return { organization, client, product }
}

export const fetchVntanaProduct = async params => {
  const { organization, client, product } = params

  const url = `${VNTANA_API_BASE}/products/${product}/organizations/${organization}/clients/${client}`

  const res = await fetch(url)

  if (!res.ok) {
    throw new Error(`VNTANA API failed: ${res.status}`)
  }

  return res.json()
}

export const findModelId = (productData, format) => {
  const models = productData?.response?.asset?.models || []

  const match = models.find(model => model.conversionFormat === format)

  return match ? match.modelBlobId : null
}

export const buildModelUrl = (params, modelId) => {
  const { organization, client, product } = params

  return `${VNTANA_API_BASE}/assets/products/${product}/organizations/${organization}/clients/${client}/${modelId}`
}

export const extractPaths = async url => {
  try {
    const params = parseVntanaUrl(url)

    const productData = await fetchVntanaProduct(params)

    const glbId = findModelId(productData, "GLB")
    const usdzId = findModelId(productData, "USDZ")

    return {
      glb: glbId ? buildModelUrl(params, glbId) : null,
      usdz: usdzId ? buildModelUrl(params, usdzId) : null,
    }
  } catch (error) {
    console.error("extractPaths error:", error)
    return { glb: null, usdz: null }
  }
}
